import script from "./ProfileMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileMenu.vue?vue&type=script&setup=true&lang=js"

import "./ProfileMenu.vue?vue&type=style&index=0&id=45222bd3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45222bd3"]])

export default __exports__